import React, { SVGProps } from 'react'

/**
 * Feature-local "replace card" glyph for the ••• actions menu (matches the
 * design prototype). Lives here rather than in src/components/Svgs, which
 * `gen-svg-components` wipes and regenerates from src/assets/svgs — this has no
 * source asset.
 */
const SvgReplaceCard = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M5 7h10l-2.5-2.5M15 13H5l2.5 2.5"
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgReplaceCard
